import React from 'react';

import useCart from 'modules/cart/util/use-cart';
import {OrderTypeEnum} from 'modules/orders/types';
import Column from 'shared/components/column';
import {MediumText, RegularText, SemiBoldText} from 'shared/components/text';
import Row from 'shared/components/row';
import Pressable from 'shared/components/pressable';
import {IoLocation} from 'react-icons/io5';
import formatAddress from 'modules/addresses/util/format-address';
import toBrl from 'shared/util/to-brl';
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom';
import useAddressesByPhone from 'modules/addresses/hooks/use-addresses-by-phone';

const CartAddress: React.FC = () => {
  const {
    cart,
    changeOrderType,
    deliveryPrice,
    companyQuery,
    deliveryPriceQuery,
    freeDeliveryThreshold,
  } = useCart();

  const navigate = useNavigate();
  const {data} = useAddressesByPhone(cart?.guestUser?.phone);

  return (
    <Container
      style={{
        width: '100%',
        alignSelf: 'flex-start',
      }}>
      <div
        style={{
          backgroundColor: '#f1f0f5',
          borderRadius: 18,
          justifyContent: 'center',
          alignSelf: 'flex-start',
          padding: 3,
          marginLeft: -3,
        }}>
        <Row justifyContent="center" alignItems="center">
          <Pressable
            onClick={() => changeOrderType()}
            style={{
              backgroundColor:
                cart?.type === OrderTypeEnum.delivery ? 'white' : undefined,
              padding: '7px 10px',
              borderRadius: 18,
            }}>
            <RegularText
              size="small"
              color={
                cart?.type === OrderTypeEnum.delivery ? 'primary' : 'text'
              }>
              Receber em casa
            </RegularText>
          </Pressable>
          <Pressable
            onClick={() => changeOrderType()}
            style={{
              backgroundColor:
                cart?.type === OrderTypeEnum.pickup ? 'white' : undefined,
              padding: '7px 10px',
              borderRadius: 18,
            }}>
            <RegularText
              size="small"
              color={cart?.type === OrderTypeEnum.pickup ? 'primary' : 'text'}>
              Retirar na loja
            </RegularText>
          </Pressable>
        </Row>
      </div>
      {cart?.type === OrderTypeEnum.delivery && (
        <Column gap={10}>
          <SemiBoldText>Endereço de entrega</SemiBoldText>
          <Row justifyContent="space-between" gap={cart?.address ? 15 : 5}>
            <IoLocation size={25} />
            <Column style={{flex: 1}}>
              <SpaceBetweenRow>
                <MediumText style={{maxWidth: '70%'}}>
                  {cart?.address
                    ? formatAddress(cart.address)
                    : 'Endereço não informado'}
                </MediumText>
                <Pressable
                  onClick={() =>
                    navigate(data?.length ? 'addresses' : 'addresses/create', {
                      state: cart?.address,
                    })
                  }>
                  <MediumText color="primary">
                    {cart?.address ? 'Trocar' : 'Informar'}
                  </MediumText>
                </Pressable>
              </SpaceBetweenRow>
              {cart?.address?.complement && (
                <RegularText>{cart?.address.complement}</RegularText>
              )}
            </Column>
          </Row>
        </Column>
      )}
      {cart?.type === OrderTypeEnum.pickup && (
        <Column gap={10}>
          <SemiBoldText>Endereço de retirada</SemiBoldText>
          <Row justifyContent="space-between" gap={15}>
            <IoLocation size={25} />
            <Column style={{flex: 1}}>
              <MediumText style={{maxWidth: '90%'}}>
                {formatAddress(companyQuery.data?.address)}
              </MediumText>
              {companyQuery?.data?.address?.complement && (
                <RegularText>
                  {companyQuery.data?.address.complement}
                </RegularText>
              )}
            </Column>
          </Row>
        </Column>
      )}
      <Column gap={10}>
        <SemiBoldText>
          {cart?.type === OrderTypeEnum.delivery ? 'Frete' : 'Retirada'}
        </SemiBoldText>
        <Row
          justifyContent="space-between"
          style={{
            border: '1px solid rgba(0, 0, 0, .5)',
            borderRadius: 4,
            padding: 15,
          }}>
          <Column>
            <MediumText>
              {cart?.type === OrderTypeEnum.delivery
                ? 'Previsão de entrega'
                : 'Previsão para retirada'}
            </MediumText>
            <RegularText size="small">
              {companyQuery.data?.deliveryTime}-
              {companyQuery.data?.deliveryTime + 15} minutos
            </RegularText>
          </Column>
          {cart?.type === OrderTypeEnum.delivery &&
            !deliveryPriceQuery.data?.freeDelivery &&
            !freeDeliveryThreshold && (
              <MediumText>{toBrl(deliveryPrice)}</MediumText>
            )}
          {(cart?.type === OrderTypeEnum.pickup ||
            deliveryPriceQuery.data?.freeDelivery ||
            !!freeDeliveryThreshold) && (
            <MediumText color="green">Grátis</MediumText>
          )}
        </Row>
      </Column>
    </Container>
  );
};

export default CartAddress;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 15px;
  padding-top: 0;
`;

export const SpaceBetweenRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
